import { useCookies } from 'react-cookie';
import { runtimeConfig } from '@plone/volto/runtime_config';
import { LOOK_COOKIE, resolveLook } from './look';

// The look to show this visitor. The cookie is read on the server too
// (Volto's CookiesProvider carries the request's cookies), so the first
// paint is already the right one.
export default function useLook() {
  const [cookies] = useCookies([LOOK_COOKIE]);
  return resolveLook(cookies[LOOK_COOKIE], runtimeConfig.RAZZLE_DEFAULT_LOOK);
}
